// 一些全局的config配置
const modeUrlObj = {
  // 线上环境
  'production': {
    // baseURL:'http://192.168.4.246:8081',
    baseURL: 'http://127.0.0.1:8081',
    devProxy: '' + '/prod-api',
    vueConfigPublicPath: '/#',
    authBaseURL: ''
  },
  // 开发环境
  'development': {
    // baseURL:'http://192.168.4.246:8081',
    baseURL: 'http://127.0.0.1:8081',
    devProxy: '' + '/dev-api',
    vueConfigPublicPath: '/#',
    authBaseURL: ''
  },
  // 测试环境
  'test': {
    baseURL: 'http://XXXX:9091/test/',
    authBaseURL: ''
  }
}
export default modeUrlObj[process.env.NODE_ENV]
